var _g, _rect, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHomeEstimationMapMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 122,
    viewBox: "0 0 112 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    filter: "url(#filter0_d_209_3569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.2159 33.6411C81.5839 32.5408 80.7189 31.5738 79.854 30.6068C77.5919 28.1394 74.9971 26.0055 72.103 24.305C67.8116 21.8042 63.1544 20.4038 58.1977 20.1037C56.4679 19.9704 54.738 20.0037 53.0082 20.0037C51.8438 20.1037 50.6795 20.2705 49.5817 20.6706C43.3942 22.0043 37.9718 24.9385 32.9154 30.04C31.1522 31.5738 29.4224 34.1079 27.9587 36.8087C26.2288 39.9763 25.0978 43.2439 24.499 46.5782C24.2661 47.4452 24.1663 48.3454 24.0998 49.2457C24.0998 49.3124 24.0998 49.3457 24.0998 49.4124C24.0665 49.7792 24.0665 50.1793 24.0333 50.5794C24 50.9796 24 51.3797 24 51.8131C24 54.714 24.3327 57.5482 25.0645 60.3823C26.3619 65.2171 28.6573 69.485 31.9174 73.2195C33.2813 74.7866 34.8115 76.2204 36.2752 77.6875C40.9325 82.3555 45.5233 87.0903 50.2471 91.6916C52.3096 93.6922 54.8711 94.3924 57.7652 93.7922C59.8943 93.3254 61.4578 92.0251 62.9548 90.5246C67.2794 86.19 71.604 81.8554 75.8953 77.5208C76.1615 77.254 76.4609 76.9539 76.727 76.6872C77.0264 76.4204 77.2925 76.187 77.5919 75.9203C79.4548 74.2198 81.1181 72.3192 82.5486 70.2519C82.6484 70.0852 82.7149 69.9518 82.7814 69.7851C86.2079 64.4502 88.0042 58.5485 87.971 51.3797C88.1373 49.0456 87.5718 46.0448 86.7069 43.0772C85.6756 39.5428 84.1786 36.4086 82.2159 33.6411Z",
    fill: "#F0553B"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 28,
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7501 64.5C47.679 64.5 46.0001 62.8211 46.0001 60.75V53.25H44.7501C43.6364 53.25 43.0787 51.9036 43.8662 51.1161L55.1162 39.8661C55.6043 39.378 56.3958 39.378 56.8839 39.8661L68.1339 51.1161C68.9214 51.9036 68.3637 53.25 67.2501 53.25H66.0001V60.75C66.0001 62.8211 64.3211 64.5 62.2501 64.5H49.7501ZM56.0001 42.5178L47.6887 50.8291C48.1627 51.0068 48.5001 51.464 48.5001 52V60.75C48.5001 61.4404 49.0597 62 49.7501 62L52.2501 61.9988L52.2501 57C52.2501 55.6193 53.3694 54.5 54.7501 54.5H57.2501C58.6308 54.5 59.7501 55.6193 59.7501 57L59.7501 61.9988L62.2501 62C62.9404 62 63.5001 61.4404 63.5001 60.75V52C63.5001 51.464 63.8374 51.0068 64.3114 50.8291L56.0001 42.5178ZM57.2501 57H54.7501L54.7501 61.9987H57.2501L57.2501 57Z",
    fill: "#47CFED"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_209_3569",
    x: 0,
    y: 0,
    width: 112,
    height: 122,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_209_3569"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_209_3569",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeEstimationMapMarker);
export default __webpack_public_path__ + "static/media/home-estimation-map-marker.7d49ffb25e9bcaa50552c0c91132ad62.svg";
export { ForwardRef as ReactComponent };